<template>
  <b-tabs
    vertical
    content-class="col-12 col-md-9 mt-1 mt-md-0"
    pills
    nav-wrapper-class="col-md-3 col-12"
    nav-class="nav-left"
  >
    <!-- info -->
    <b-tab active>
      <!-- title -->
      <template #title>
        <feather-icon icon="SettingsIcon" size="18" class="mr-50" />
        <span class="font-weight-bold">General</span>
      </template>

      <wallet-general-settings />
    </b-tab>

    <!-- general tab -->
    <b-tab>
      <!-- title -->
      <template #title>
        <feather-icon icon="BriefcaseIcon" size="18" class="mr-50" />
        <span class="font-weight-bold">Wallet Address</span>
      </template>

      <wallet-address-settings />
    </b-tab>
    <!--/ general tab -->

    <!-- change password tab -->
    <b-tab>
      <!-- title -->
      <template #title>
        <feather-icon icon="LockIcon" size="18" class="mr-50" />
        <span class="font-weight-bold">Wallet Content</span>
      </template>

      <wallet-contents />
    </b-tab>
    <!--/ change password tab -->

    <!-- notification -->
    <b-tab>
      <!-- title -->
      <template #title>
        <feather-icon icon="BellIcon" size="18" class="mr-50" />
        <span class="font-weight-bold">Notifications</span>
      </template>

      <account-setting-notification
        v-if="options.notification"
        :notification-data="options.notification"
      />
    </b-tab>
  </b-tabs>
</template>

<script>
import { BTabs, BTab } from "bootstrap-vue";
import AccountSettingGeneral from "./AccountSettingGeneral.vue";
import AccountSettingPassword from "./AccountSettingPassword.vue";
import AccountSettingInformation from "./AccountSettingInformation.vue";
import AccountSettingSocial from "./AccountSettingSocial.vue";
import AccountSettingNotification from "./AccountSettingNotification.vue";
import WalletAddressSettings from "./WalletAddressSettings.vue";
import WalletGeneralSettings from "./WalletGeneralSettings.vue";
import WalletContents from "./WalletContents.vue";

export default {
  components: {
    BTabs,
    BTab,
    AccountSettingGeneral,
    AccountSettingPassword,
    AccountSettingInformation,
    AccountSettingSocial,
    AccountSettingNotification,
    WalletAddressSettings,
    WalletGeneralSettings,
    WalletContents,
  },
  data() {
    return {
      options: {},
    };
  },
  beforeCreate() {
    this.$http.get("/account-setting/data").then((res) => {
      this.options = res.data;
    });
  },
};
</script>
